<template>
  <div class="calendar-component" :style="styleObject">
    <div class="calendar-title" v-if="getShowTitle" :style="styleTitle">
      <div v-if="styleId === 1 || styleId === 3">
        <button
          class="title-btn prev-month"
          @click="selectDate('prev-month')"
          v-if="showButton"
          :style="leftButtonStyle"
        >
          <div class="bg-box" :style="getIconBgStyle">
            <cxIcon v-if="buttonIconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
            <img v-else-if="buttonIconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
          </div>
        </button>
        <p class="title-txt">{{ calendarTitle }}</p>
        <button
          class="title-btn next-month"
          @click="selectDate('next-month')"
          v-if="showButton"
          :style="rightButtonStyle"
        >
          <div class="bg-box" :style="getIconBgStyle">
            <cxIcon v-if="buttonIconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
            <img v-else-if="buttonIconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
          </div>
        </button>
      </div>
      <div v-if="styleId === 2" class="calendar-title-select flex-right">
        <el-select
          popper-class="date-select"
          class="mr12"
          v-model="dateMonthStyle"
          placeholder="请选择"
          @change="changeSelectOptionMonth"
          :popper-append-to-body="false"
        >
          <el-option v-for="item in dateMonthOptions" :key="item.label" :label="item.label" :value="item.label">
          </el-option>
        </el-select>
        <el-select
          popper-class="date-select"
          v-model="dateYearStyle"
          placeholder="请选择"
          @change="changeSelectOptionYear"
          :popper-append-to-body="false"
        >
          <el-option v-for="item in dateYearOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-calendar
      v-if="styleId !== 3"
      v-model="calendarValue"
      ref="elCalendar"
      :format="getDateContent"
      :firstDayOfWeek="firstDayOfWeek"
      @input="pickDay"
      :style="dateStyleObject"
      :class="{
        'hide-notCurrentDate': !showNotCurrentDate,
        'hide-todayStyle': !showTodayStyle,
        'day-box-style1': styleId === 1,
        'day-box-style2': styleId === 2
      }"
    >
      <template slot="dateCell" slot-scope="{ date, data }">
        <div class="day-box" :class="{ selected: isSelected(date, data) }" :style="dateInnerStyleObject">
          <div class="solar">{{ data.day.split("-")[2] }}</div>
          <div class="lunar" v-if="showLunar" :class="{ festival: isFestival(date, data) }">
            {{ solarToLunar(date, data) }}
          </div>
          <i v-if="styleId === 1" class="activity-mark"></i>
          <div
            v-if="styleId === 2 && activityDateNumber(date, data)"
            class="activity-mark activity-mark-number"
            :style="activityMarkStyle"
          >
            {{ activityDateNumber(date, data) }}
          </div>
          <div
            v-if="styleId === 2 && activityDateNumber(date, data) && activityTooltip && activityLists.length > 0"
            class="activity-tooltip"
            :style="activityTooltipStyle"
          >
            <ul>
              <li v-for="(item, index) in activityLists" :style="activityTooltipLiStyle"
                  v-if="isDateHasData(item, data)">
                <p class="" :style="activityTooltipNameStyle">
                  <span v-if="contentHasLimit">
                    {{ item.title.slice(0, textLimitLines) }}<span v-if="item.title.length > textLimitLines">...</span>
                  </span>
                  <span v-else>{{ item.title }}</span>
                </p>
                <p class="" :style="activityTooltipTimeStyle">{{ item.time }}</p>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </el-calendar>
    <el-calendar
      v-if="styleId === 3 && starttime && endtime"
      :range="[starttime, endtime]"
      v-model="calendarValue"
      ref="elCalendar"
      :format="getDateContent"
      :firstDayOfWeek="firstDayOfWeek"
      @input="pickDay"
      :style="dateStyleObject"
      :class="{
        'hide-notCurrentDate': !showNotCurrentDate,
        'hide-todayStyle': !showTodayStyle
      }"
    >
      <template slot="dateCell" slot-scope="{ date, data }">
        <div
          class="day-box day-box-style3"
          :class="{ selected: isSelected(date, data) }"
          :style="{ ...dateInnerStyleObject, ...dateInnerStyle3 }"
        >
          <div class="solar">{{ data.day.split("-")[2] }}</div>
          <div
            class="lunar"
            v-if="showLunar"
            :class="{
              festival: isFestival(date, data),
              lunarTxt1: todayLunarType === 1,
              lunarTxt2: todayLunarType === 2,
              lunarTxt3: todayLunarType === 3
            }"
            :style="{...todayLunarStyleObject}"
          >
            <span class="lunar-default"> {{ solarToLunar(date, data) }}</span>
            <span class="lunar-self"> {{ selfLunarTxt }}</span>
          </div>
          <i class="activity-mark" :style="activityMarkStyle3"></i>
        </div>
      </template>
    </el-calendar>
    <div
      v-if="styleId !== 3"
      class="calendar-footer"
      :style="legendStyle"
      :class="options.legendPosition == '0' ? 'tl' : 'tr'"
    >
      <div
        class="icon-today mr24 pointer"
        @click="selectDate('today')"
        :style="legendSpaceStyle"
        v-if="options.showTodayLegend"
      >
        <i class="icon-circle mr6" :style="iconStyle1"></i><span :style="textStyle1">{{ options.todayLegendVal }}</span>
      </div>
      <div class="icon-activity" v-if="options.showActivityLegend">
        <i class="icon-bg mr6" :style="iconStyle2"></i><span :style="textStyle2">{{ options.activityLegendVal }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import { calendarPlugin } from "./calendarPlugin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import plugins from "./plugin"

const validTypes = ["prev-month", "today", "next-month"]

export default {
  mixins: [eventMixin, plugins, subPageEventMixin],
  name: "cxCalendar",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  components: {},
  watch: {
    styleId(n, o) {
      if (n === 3 && n !== o) {
        this.getRangeTime()
      }
    },
    firstDayOfWeek(n, o) {
      if (n !== o && this.styleId === 3) {
        this.getRangeTime()
      }
    },
  },
  data() {
    return {
      showInput: true,
      showPicker: false,
      showPicker2: false,
      todayNow: new Date(),
      calendarValue: new Date(),
      calendarTitle: "",
      hasRelativePlugin: false,
      dateMonthOptions: [
        {
          label: "01"
        },
        {
          label: "02"
        },
        {
          label: "03"
        },
        {
          label: "04"
        },
        {
          label: "05"
        },
        {
          label: "06"
        },
        {
          label: "07"
        },
        {
          label: "08"
        },
        {
          label: "09"
        },
        {
          label: "10"
        },
        {
          label: "11"
        },
        {
          label: "12"
        }
      ],
      dateYearOptions: [],
      dateMonthStyle: "",
      dateYearStyle: "",
      selectedDay: false,
      starttime: "", //样式3周展示的开始日期
      endtime: "", //样式3周展示的结束日期
      isInListPage: false,
      isInSubPage: false,
    }
  },
  computed: {
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            if (bg.data.stops.length > 0) {
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            if (bg.data.stops.length > 0) {
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    styleObject() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let thisStyle = {
        color: this.$parseColor(this.options.color),
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor,{isThemeColor: this.options.borderIsThemeColor}),
        "border-width": borderW,
        "box-shadow": this.boxShadowStyle,
        // "background-image": "url(" + this.options.imgSrc + ")",
        // "background-repeat": this.options.repeatType,
        // "background-size": this.options.clipSize,
        // "background-position": this.options.alignType,
        opacity: this.options.opacity,
        padding: this.getPaddingStyle
      }
      return {
        ...this.bgStyle,
        ...thisStyle
      }
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.paddingTypeFlag || this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getShowTitle() {
      return this.options ? this.options.showTitle : true
    },
    getDateContent() {
      let pickerDateY = 0
      let pickerDateM = 0

      if (this.$refs.elCalendar) {
        pickerDateY = this.$refs.elCalendar.date.getFullYear()
        pickerDateM = this.$refs.elCalendar.date.getMonth() + 1
      } else {
        pickerDateY = this.calendarValue.getFullYear()
        pickerDateM = this.calendarValue.getMonth() + 1
      }
      if (pickerDateM < 10) {
        this.dateMonthStyle = "0" + pickerDateM
      } else {
        this.dateMonthStyle = pickerDateM
      }
      this.dateYearStyle = pickerDateY

      let showDate = ""
      switch (this.options.dateStyle) {
        case "1":
          // "2021年11月"
          showDate = `yyyy年MM月`
          if (this.$refs.elCalendar && pickerDateM < 9) {
            pickerDateM = "0" + pickerDateM
          }
          showDate = pickerDateY + "年" + pickerDateM + "月"
          break
        case "2":
          // "2021年 十一月"
          var str = "一"
          if (pickerDateM) {
            if (pickerDateM == 2) {
              str = "二"
            } else if (pickerDateM == 3) {
              str = "三"
            } else if (pickerDateM == 4) {
              str = "四"
            } else if (pickerDateM == 5) {
              str = "五"
            } else if (pickerDateM == 6) {
              str = "六"
            } else if (pickerDateM == 7) {
              str = "七"
            } else if (pickerDateM == 8) {
              str = "八"
            } else if (pickerDateM == 9) {
              str = "九"
            } else if (pickerDateM == 10) {
              str = "十"
            } else if (pickerDateM == 11) {
              str = "十一"
            } else if (pickerDateM == 12) {
              str = "十二"
            } else {
              str = "一"
            }
          }
          // showDate = `yyyy年` + str + `月`
          showDate = pickerDateY + "年" + str + "月"
          break
        case "3":
          // showDate = `yyyy-MM`
          if (pickerDateM < 10) {
            pickerDateM = "0" + pickerDateM
          }
          showDate = pickerDateY + "-" + pickerDateM
          break
        case "4":
          // showDate = `yyyy / MM`
          if (pickerDateM < 10) {
            pickerDateM = "0" + pickerDateM
          }
          showDate = pickerDateY + " / " + pickerDateM
          break
        default:
      }
      this.calendarTitle = showDate
      return showDate
    },
    getTitlePaddingStyle() {
      let padding = `${this.options.titlePadding}px`
      if (!this.options.titlePaddingTypeFlag || this.options.titlePaddingTypeFlag === 2) {
        padding = ` ${this.options.titlePaddingTop}px  ${this.options.titlePaddingRight}px  ${this.options.titlePaddingBottom}px  ${this.options.titlePaddingLeft}px`
      }
      return padding
    },
    styleTitle() {
      let selectBorderW = ""
      if (Array.isArray(this.options.titleBorderWidth)) {
        this.options.titleBorderWidth.forEach(item => [(selectBorderW += ` ${item}px`)])
      } else {
        selectBorderW += ` ${this.options.titleBorderWidth}px`
      }
      let titleSelectPaddingStr = `${this.options.titlePadding2}px`
      if (!this.options.titlePaddingTypeFlag2 || this.options.titlePaddingTypeFlag2 === 2) {
        titleSelectPaddingStr = ` ${this.options.titlePaddingTop2}px  ${this.options.titlePaddingRight2}px  ${this.options.titlePaddingBottom2}px  ${this.options.titlePaddingLeft2}px`
      }
      return {
        "font-Family": this.options.titleFontFamily,
        "--titleFontFamily": this.options.titleFontFamily,
        "font-size": this.options.titleFontSize + "px",
        "--titleFontSize": this.options.titleFontSize + "px",
        "font-weight": this.options.titleFontWeight,
        "line-height": this.options.titleLineHeightType === '%' ? (this.options.titleLineHeight/100) : ( this.options.titleLineHeight + "px"),
        "--titleLineHeight": this.options.titleLineHeight + "px",
        "font-style": this.options.titleFontStyle,
        "text-align": this.options.titleTextAlign,
        "writing-mode": this.options.titleWritingMode,
        "letter-spacing": this.options.titleLetterSpacing + "px",
        "text-decoration": this.options.titleTextDecoration,
        "--titleTextDecoration": this.options.titleTextDecoration,
        "--topSelectBgColor":this.$parseColor(this.options.topSelectBgColor,{isThemeColor:this.options.topSelectBgColorIsThemeColor }) || '#363B5D',
        "text-decoration-color": this.$parseColor(this.options.color),
        color: this.$parseColor(this.options.titleColor, {isThemeColor:
        this.options.titleTextIsThemeColor }),
        opacity: this.options.opacity,
        "background-color": this.$parseColor(this.options.titleBgColor, {isThemeColor:
          this.options.titleBgColorIsThemeColor }),
        padding: this.getTitlePaddingStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "--titleSelectBgColor":
            this.$parseColor(this.options.titleSelectBgColor, {isThemeColor:this.options.titleSelectBgIsThemeColor}),
        "--titleSelectBorderWidth": selectBorderW,
        "--titleSelectBorderStyle": this.options.titleBorderStyle || "solid",
        "--titleSelectBorderColor":
            this.$parseColor(this.options.titleBorderIsThemeColor, {isThemeColor:this.options.titleBorderColor}),
        "--titleSelectBorderRadius": `${this.options.titleBorderTopLeftRadius}px ${this.options.titleBorderTopRightRadius}px ${this.options.titleBorderBottomRightRadius}px ${this.options.titleBorderBottomLeftRadius}px`,
        "--titleSelectLineHeight": this.options.selectOptionsHeight + "px",
        "--titleSelectPadding": titleSelectPaddingStr,
        "--titleSelectBoxshadow": this.titleSelectBoxshadowStyle,
        "--titleSelectFontFamily": this.options.titleSelectFontFamily,
        "--titleSelectFontSize": this.options.titleSelectFontSize + "px",
        "--titleSelectFontWeight": this.options.titleSelectFontWeight || 400,
        "--titleSelectColor": this.$parseColor(this.options.titleSelectColor),
        "--titleSelectOptionsBgColor": this.$parseColor(this.options.titleSelectOptionsBgColor,{isThemeColor:this.options.titleSelectOptionsBgIsThemeColor}),
        "--titleSelectActiveFontFamily": this.options.titleSelectActiveFontFamily,
        "--titleSelectActiveFontSize": this.options.titleSelectActiveFontSize + "px",
        "--titleSelectActiveFontWeight": this.options.titleSelectActiveFontWeight || 400,
        "--titleSelectActiveColor": this.$parseColor(this.options.titleSelectActiveColor),
        "--titleSelectActiveBgColor": this.$parseColor(this.options.titleSelectActiveBgColor,{isThemeColor:this.options.titleSelectActiveBgIsThemeColor}),
        "--selectWidth": this.options.selectWidth ? ( this.options.selectWidth + "px" ) : "100px"
      }
    },
    titleSelectBoxshadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.titleBoxShadowH)) {
        this.options.titleBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          if (_this.options.titleBoxShadowH[index]) {
            tmpStyle +=
                `${_this.options.titleBoxShadowH[index]}px ${_this.options.titleBoxShadowV[index]}px ${_this.options.titleBoxShadowBlur[index]}px ${_this.options.titleBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.titleBoxShadowColor[index])}`
          }
        })
      } else {
        tmpStyle +=
            `${this.options.titleBoxShadowH}px ${this.options.titleBoxShadowV}px ${this.options.titleBoxShadowBlur}px ${this.options.titleBoxShadowSpread}px ${this.$parseColor(this.options.titleBoxShadowColor)}`
      }
      return tmpStyle
    },
    showLunar() {
      return this.options ? this.options.showLunar : true
    },
    dateStyleObject() {
      return {
        "font-Family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        "font-style": this.options.fontStyle,
        color: this.$parseColor(this.options.color),
        "--weekColor": this.$parseColor(this.options.weekColor),
        "--weekFontFamily": this.options.weekFontFamily,
        "--weekFontSize": this.options.weekFontSize + "px",
        "--weekFontWeight": this.options.weekFontWeight,
        "--weekBgColor":  this.$parseColor(this.options.weekBgColor,{isThemeColor:this.options.weekBgColorIsThemeColor}),
      }
    },
    firstDayOfWeek() {
      return this.options ? this.options.firstDayOfWeek : 7
    },
    lunarStyleObject() {
      return {
        color: this.$parseColor(this.options.lunarColor),
        "font-Family": this.options.lunarFontFamily,
        "font-size": this.options.lunarFontSize + "px",
        "font-weight": this.options.lunarFontWeight
      }
    },
    showNotCurrentDate() {
      return this.options ? this.options.showNotCurrentDate : true
    },
    showTodayStyle() {
      return this.options ? this.options.showTodayStyle : true
    },
    activeMark() {
      return this.options && this.options.activeMark ? this.options.activeMark : "type0"
    },
    dateInnerStyleObject() {
      let HBorderW = "",
        ABorderW = "",
        TodayBorderW = "",
        AtBorderW = ""
      if (Array.isArray(this.options.hoverBorderWidth)) {
        this.options.hoverBorderWidth.forEach(item => [(HBorderW += ` ${item}px`)])
      } else {
        HBorderW += ` ${this.options.hoverBorderWidth}px`
      }
      if (!this.options.showHoverBorder) {
        HBorderW = 0
      }
      if (Array.isArray(this.options.activeBorderWidth)) {
        this.options.activeBorderWidth.forEach(item => [(ABorderW += ` ${item}px`)])
      } else {
        ABorderW += ` ${this.options.activeBorderWidth}px`
      }
      if (!this.options.showActiveBorder) {
        ABorderW = 0
      }
      //今日样式边框宽度
      if (Array.isArray(this.options.todayStyleBorderWidth)) {
        this.options.todayStyleBorderWidth.forEach(item => [(TodayBorderW += ` ${item}px`)])
      } else {
        TodayBorderW += ` ${this.options.todayStyleBorderWidth}px`
      }
      if (!this.options.showTodayStyleBorder) {
        TodayBorderW = 0
      }

      // 活动标记日日期边框
      if (Array.isArray(this.options.activityBorderWidth)) {
        this.options.activityBorderWidth.forEach(item => [(AtBorderW += ` ${item}px`)])
      } else {
        AtBorderW += ` ${this.options.activityBorderWidth}px`
      }
      if (!this.options.showActivityMark) {
        AtBorderW = 0
      }

      let innerDateStyle = {
        "--notCurrentTextColor": this.$parseColor(this.options.notCurrentTextColor,{isThemeColor:this.options.notCurrentTextIsThemeColor}),
        "--lunarColor": this.$parseColor(this.options.lunarColor),
        "--lunarFontFamily": this.options.lunarFontFamily,
        "--lunarFontSize": this.options.lunarFontSize + "px",
        "--lunarFontWeight": this.options.lunarFontWeight,
        "--hoverLunarColor": this.$parseColor(this.options.lunarHoverColor),
        "--hoverLunarFontFamily": this.options.lunarHoverFontFamily,
        "--hoverLunarFontSize": this.options.lunarHoverFontSize + "px",
        "--hoverLunarFontWeight": this.options.lunarActiveFontWeight,
        "--activeLunarColor": this.$parseColor(this.options.lunarActiveColor),
        "--activeLunarFontFamily": this.options.lunarActiveFontFamily,
        "--activeLunarFontSize": this.options.lunarActiveFontSize + "px",
        "--activeLunarFontWeight": this.options.lunarActiveFontWeight,
        "--hoverColor": this.$parseColor(this.options.hoverColor),
        "--hoverFontFamily": this.options.hoverFontFamily,
        "--hoverFontSize": this.options.hoverFontSize + "px",
        "--hoverFontWeight": this.options.hoverFontWeight,
        "--hoverBorderTopLeftRadius": this.options.hoverBorderTopLeftRadius + "px",
        "--hoverBorderTopRightRadius": this.options.hoverBorderTopRightRadius + "px",
        "--hoverBorderBottomRightRadius": this.options.hoverBorderBottomRightRadius + "px",
        "--hoverBorderBottomLeftRadius": this.options.hoverBorderBottomLeftRadius + "px",
        "--hoverBorderWidth": HBorderW,
        "--hoverBorderStyle": this.options.hoverBorderStyle,
        "--hoverBorderColor": this.$parseColor(this.options.hoverBorderColor,{isThemeColor:this.options.hoverBorderIsThemeColor}),
        "--hoverBgColor": this.$parseColor(this.options.hoverBgColor,{isThemeColor:this.options.hoverBgColorIsThemeColor}),
        "--hoverAllBgColor": this.$parseColor(this.options.hoverAllBgColor,{isThemeColor:this.options.hoverAllBgColorIsThemeColor}),
        "--activeColor": this.$parseColor(this.options.activeColor),
        "--activeFontFamily": this.options.activeFontFamily,
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeBorderTopLeftRadius": this.options.activeBorderTopLeftRadius + "px",
        "--activeBorderTopRightRadius": this.options.activeBorderTopRightRadius + "px",
        "--activeBorderBottomRightRadius": this.options.activeBorderBottomRightRadius + "px",
        "--activeBorderBottomLeftRadius": this.options.activeBorderBottomLeftRadius + "px",
        "--activeBorderWidth": ABorderW,
        "--activeBorderStyle": this.options.activeBorderStyle,
        "--activeBorderColor":this.$parseColor(this.options.activeBorderColor,{isThemeColor:this.options.activeBorderIsThemeColor}),
        "--activeBgColor": this.$parseColor(this.options.activeBgColor,{isThemeColor:this.options.activeBgColorIsThemeColor}),
        "--datePaddingTopVal": this.options.datePaddingTopVal + "px",
        "--datePaddingBottomVal": this.options.datePaddingBottomVal + "px",
        "--activeAllBgColor": this.$parseColor(this.options.activeAllBgColor,{isThemeColor:this.options.activeAllBgColorIsThemeColor}),
      }
      let todayStyle = {}
      if (this.options.showTodayStyle) {
        todayStyle = {
          "--todayStyleColor": this.$parseColor(this.options.todayStyleColor),
          "--todayStyleFontFamily": this.options.todayStyleFontFamily,
          "--todayStyleFontSize": this.options.todayStyleFontSize + "px",
          "--todayStyleFontWeight": this.options.todayStyleFontWeight,
          "--todayStyleBorderTopLeftRadius": this.options.todayStyleBorderTopLeftRadius + "px",
          "--todayStyleBorderTopRightRadius": this.options.todayStyleBorderTopRightRadius + "px",
          "--todayStyleBorderBottomRightRadius": this.options.todayStyleBorderBottomRightRadius + "px",
          "--todayStyleBorderBottomLeftRadius": this.options.todayStyleBorderBottomLeftRadius + "px",
          "--todayStyleBorderWidth": TodayBorderW,
          "--todayStyleBorderStyle": this.options.todayStyleBorderStyle,
          "--todayStyleBorderColor": this.$parseColor(this.options.todayStyleBorderColor,{isThemeColor:this.options.todayStyleBorderIsThemeColor}),
          "--todayStyleBgColor": this.$parseColor(this.options.todayStyleBgColor,{isThemeColor:this.options.todayStyleBgColorIsThemeColor}),
          "--todayAllBgColor": this.$parseColor(this.options.todayAllBgColor,{isThemeColor:this.options.todayAllBgColorIsThemeColor}),
        }
      }
      let activityStyle = {}
      if (this.options.showActivityMark) {
        activityStyle = {
          "--activityWidth": this.options.activityWidth + "px",
         /* "--activityColor": this.options.activityColorIsThemeColor
            ? this.themeColor
            : this.options.activityColor.color,*/
          "--activityColor": this.$parseColor(this.options.activityBgColor,{isThemeColor:this.options.activityBgColorIsThemeColor}),
          "--activityFontColor": this.$parseColor(this.options.activityFontColor),
          "--activityFontFamily": this.options.activityFontFamily,
          "--activityFontSize": this.options.activityFontSize + "px",
          "--activityFontWeight": this.options.activityFontWeight,
          "--activityBorderTopLeftRadius": this.options.activityBorderTopLeftRadius + "px",
          "--activityBorderTopRightRadius": this.options.activityBorderTopRightRadius + "px",
          "--activityBorderBottomRightRadius": this.options.activityBorderBottomRightRadius + "px",
          "--activityBorderBottomLeftRadius": this.options.activityBorderBottomLeftRadius + "px",
          "--activityBorderWidth": AtBorderW,
          "--activityBorderStyle": this.options.activityBorderStyle,
          "--activityBorderColor": this.$parseColor(this.options.activityBorderColor,{isThemeColor:this.options.activityBorderIsThemeColor}),
        }
      }

      return {
        ...innerDateStyle,
        ...todayStyle,
        ...activityStyle
      }
    },
    showButton() {
      return this.options ? this.options.showButton : true
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    buttonIconType() {
      return this.options ? this.options.buttonIconType : "img"
    },
    getIconStyle() {
      return {
        display: "inline-block",
        "--color": this.$parseColor(this.options.buttonIconColor,{isThemeColor:this.options.iconColorIsThemeColor}),
        fontSize: this.options.buttonIconSize + "px",
        width: this.options.buttonIconSize + "px",
        height: this.options.buttonIconSize + "px"
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.buttonIconSize + "px"
      }
    },
    buttonBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.buttonBoxShadowH)) {
        this.options.buttonBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.buttonBoxShadowH[index]}px ${_this.options.buttonBoxShadowV[index]}px ${_this.options.buttonBoxShadowBlur[index]}px ${_this.options.buttonBoxShadowSpread[index]}px ${
              _this.$parseColor(_this.options.buttonBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.buttonBoxShadowH}px ${this.options.buttonBoxShadowV}px ${this.options.buttonBoxShadowBlur}px ${this.options.buttonBoxShadowSpread}px ${
            this.$parseColor(this.options.buttonBoxShadowColor)}`
      }
      return tmpStyle
    },
    getIconBgStyle() {
      return {
        "background-color":this.$parseColor(this.options.buttonIconBackgroundColor,{isThemeColor:this.options.iconBgIsThemeColor}),
        width: this.options.buttonIconBackgroundWidth + "px",
        height: this.options.buttonIconBackgroundHeight + "px",
        "border-radius": this.options.buttonIconBackGroundBorderRadius + "px",
        "box-shadow": this.buttonBoxShadowStyle
      }
    },
    leftButtonStyle() {
      return {
        left: this.options.buttonIconCustomTop
          ? this.options.leftButtonIconX + "px"
          : this.options.buttonIconPadding + "px",
        top: this.options.buttonIconCustomTop ? this.options.leftButtonIconY + "px" : "50%"
      }
    },
    rightButtonStyle() {
      return {
        right: this.options.buttonIconCustomTop
          ? this.options.rightButtonIconX + "px"
          : this.options.buttonIconPadding + "px",
        top: this.options.buttonIconCustomTop ? this.options.rightButtonIconY + "px" : "50%"
      }
    },
    legendStyle() {
      return {
        padding: this.getLegendPaddingStyle
      }
    },
    getLegendPaddingStyle() {
      let legendPadding = `${this.options.legendPadding}px`
      if (!this.options.legendPaddingTypeFlag || this.options.legendPaddingTypeFlag === 2) {
        legendPadding = ` ${this.options.legendPaddingTop}px  ${this.options.legendPaddingRight}px  ${this.options.legendPaddingBottom}px  ${this.options.legendPaddingLeft}px`
      }
      return legendPadding
    },
    iconStyle1() {
      let borderR1 = ""
      if (this.options.todayLegendShapeType == "round") {
        borderR1 = "50%"
      } else {
        borderR1 = this.options.todayLegendBorderRadius + "px"
      }
      if (this.options.todayLegendBgType == 0) {
        this.options.todayLegendBgColor = this.$parseColor(this.options.todayLegendBorderColor,{isThemeColor:this.options.todayLegendBorderIsThemeColor})
      } else {
        this.options.todayLegendBgColor = "transparent"
      }
      return {
        "background-color": this.$parseColor(this.options.todayLegendBgColor),
        "border-radius": borderR1,
        width: this.options.todayLegendWidth + "px",
        height: this.options.todayLegendHeight + "px",
        "border-color":
            this.$parseColor(this.options.todayLegendBorderColor,{isThemeColor:this.options.todayLegendBorderIsThemeColor}),
      }
    },
    iconStyle2() {
      let borderR2 = ""
      if (this.options.activityLegendShapeType == "round") {
        borderR2 = "50%"
      } else {
        borderR2 = this.options.activityLegendBorderRadius + "px"
      }
      if (this.options.activityLegendBgType == 0) {
        this.options.activityLegendBgColor = this.$parseColor(this.options.activityLegendBorderColor,{isThemeColor:this.options.activityLegendBorderIsThemeColor})
      } else {
        this.options.activityLegendBgColor = "transparent"
      }
      return {
        "background-color": this.$parseColor(this.options.activityLegendBgColor),
        "border-radius": borderR2,
        width: this.options.activityLegendWidth + "px",
        height: this.options.activityLegendHeight + "px",
        "border-color":
            this.$parseColor(this.options.activityLegendBorderColor,{isThemeColor:this.options.activityLegendBorderIsThemeColor}),
      }
    },
    textStyle1() {
      return {
        "font-Family": this.options.todayLegendFontFamily,
        "font-size": this.options.todayLegendFontSize + "px",
        "font-weight": this.options.todayLegendFontWeight,
        color: this.$parseColor(this.options.todayLegendColor)
      }
    },
    textStyle2() {
      return {
        "font-Family": this.options.activityLegendFontFamily,
        "font-size": this.options.activityLegendFontSize + "px",
        "font-weight": this.options.activityLegendFontWeight,
        color: this.$parseColor(this.options.activityLegendColor)
      }
    },
    legendSpaceStyle() {
      return {
        "margin-right": this.options.legendSpace + "px"
      }
    },
    pickDate() {
      return this.options.pickDate
    },
    selectedDates() {
      let datas = this.options.selectedDates
      /*if (!datas.length) {
        datas = ["2024-02-20"]
      }*/
      return datas
    },
    activityLists() {
      let lists = this.options.activityLists || []
      /*if (!lists.length) {
        lists = [
          {
            title: "学工培训系统1",
            time: "22:00"
          },
          {
            title: "学工培训系统2",
            time: "23:00"
          }
        ]
      }*/
      return lists
    },
    selectedDateMap() {
      let datasMap = this.options.selectedDateMap || []
      /*if (!datasMap.length) {
        datasMap = [{ "2024-02-20": 1 }, { "2024-02-21": 2 }]
      }*/
      return datasMap
    },
    styleId() {
      return this.options.styleId
    },
    activityMarkStyle() {
      let activityLocation = Number(this.options.activityLocation) || 3
      let locationStr, locationStrTop, locationStrRight, locationStrLeft, locationStrBottom
      if (activityLocation === 1) {
        //  顶部居左
        locationStr = {
          left: 0,
          right: "auto",
          top: "-10px",
          bottom: "auto"
        }
      } else if (activityLocation === 2) {
        //  顶部居中
        locationStr = {
          left: "50%",
          right: 0,
          top: "-10px",
          bottom: "auto"
        }
      } else if (activityLocation === 3) {
        //  顶部居右
        locationStr = {
          left: "auto",
          right: 0,
          top: "-10px",
          bottom: "auto"
        }
      } else if (activityLocation === 4) {
        //  底部居左
        locationStr = {
          left: 0,
          right: 0,
          top: "auto",
          bottom: 0
        }
      } else if (activityLocation === 5) {
        //  底部居中
        locationStr = {
          left: "50%",
          right: 0,
          top: "auto",
          bottom: 0
        }
      } else if (activityLocation === 6) {
        //  底部居右
        locationStr = {
          left: "auto",
          right: 0,
          top: "auto",
          bottom: 0
        }
      } else {
        locationStr = {
          left: "70%",
          right: 0,
          top: "-10px",
          bottom: "auto"
        }
      }
      locationStrTop = locationStr.top
      locationStrRight = locationStr.right
      locationStrLeft = locationStr.left
      locationStrBottom = locationStr.bottom
      return {
        "font-Family": this.options.activityFontFamily,
        "font-size": this.options.activityFontSize + "px",
        "font-weight": this.options.activityFontWeight,
        color: this.$parseColor(this.options.activityFontColor),
        width: this.options.activityWidth + "px",
        height: this.options.activityWidth + "px",
        "border-radius": this.options.activityBorderRadius + "px",
        "background-color": this.$parseColor(this.options.activityBgColor,{isThemeColor:this.options.activityBgColorIsThemeColor}),
        "--activityMarkTop": locationStrTop,
        "--activityMarkRight": locationStrRight,
        "--activityMarkLeft": locationStrLeft,
        "--activityMarkBottom": locationStrBottom
      }
    },
    activityTooltip() {
      return this.options.activityTooltip || false
    },

    activityTooltipBoxshadow() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.tooltipBoxShadowH)) {
        this.options.tooltipBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          if (_this.options.tooltipBoxShadowH[index]) {
            tmpStyle +=
                `${_this.options.tooltipBoxShadowH[index]}px ${_this.options.tooltipBoxShadowV[index]}px ${_this.options.tooltipBoxShadowBlur[index]}px ${_this.options.tooltipBoxShadowSpread[index]}px ${ _this.$parseColor(_this.options.tooltipBoxShadowColor[index])}`
          }
        })
      } else {
        tmpStyle +=
            `${this.options.tooltipBoxShadowH}px ${this.options.tooltipBoxShadowV}px ${this.options.tooltipBoxShadowBlur}px ${this.options.tooltipBoxShadowSpread}px ${ this.$parseColor(this.options.tooltipBoxShadowColor)}`
      }
      return tmpStyle
    },
    activityTooltipStyle() {
      let tooltipBorderRadiusStr = `${this.options.tooltipBorderRadius}px`
      if (!this.options.tooltipBorderTypeFlag || this.options.tooltipBorderTypeFlag === 1) {
        tooltipBorderRadiusStr = `${this.options.tooltipBorderTopLeftRadius}px ${this.options.tooltipBorderTopRightRadius}px ${this.options.tooltipBorderBottomRightRadius}px ${this.options.tooltipBorderBottomLeftRadius}px`
      }
      let tooltipBorderWidthStr = ""
      if (Array.isArray(this.options.tooltipBorderWidth)) {
        this.options.tooltipBorderWidth.forEach(item => [(tooltipBorderWidthStr += ` ${item}px`)])
      } else {
        tooltipBorderWidthStr += ` ${this.options.tooltipBorderWidth}px`
      }
      let tooltipPaddingStr = `${this.options.tooltipPadding}px`
      if (!this.options.tooltipPaddingTypeFlag || this.options.tooltipPaddingTypeFlag === 2) {
        tooltipPaddingStr = ` ${this.options.tooltipPaddingTop}px  ${this.options.tooltipPaddingRight}px  ${this.options.tooltipPaddingBottom}px  ${this.options.tooltipPaddingLeft}px`
      }
      return {
        width: this.options.activityTooltipWidth + "px",
        height: this.options.activityTooltipHeight + "px",
        "background-color":this.$parseColor(this.options.activityTooltipBgColor,{isThemeColor:this.options.activityTooltipBgIsThemeColor}),
        "--tooltipBorderRadius": tooltipBorderRadiusStr,
        "--tooltipBorderWidth": tooltipBorderWidthStr,
        "--tooltipBorderStyle": this.options.tooltipBorderStyle,
        "--tooltipBorderColor": this.$parseColor(this.options.tooltipBorderColor,{isThemeColor:this.options.tooltipBorderIsThemeColor}),
        padding: tooltipPaddingStr,
        "--activityTooltipBoxshadow": this.activityTooltipBoxshadow
      }
    },
    contentHasLimit() {
      return this.options.contentHasLimit
    },
    textLimitLines() {
      return this.options.textLimitLines
    },
    activityTooltipLiStyle() {
      return {
        height: this.options.activityLineHeight + "px",
        "line-height": this.options.activityLineHeight + "px"
      }
    },
    activityTooltipNameStyle() {
      return {
        color:  this.$parseColor(this.options.tooltipTitleColor),
        "font-Family": this.options.tooltipTitleFontFamily,
        "font-size": this.options.tooltipTitleFontSize + "px",
        "font-weight": this.options.tooltipTitleFontWeight
      }
    },
    activityTooltipTimeStyle() {
      return {
        color:  this.$parseColor(this.options.tooltipTimeColor),
        "font-Family": this.options.tooltipTimeFontFamily,
        "font-size": this.options.tooltipTimeFontSize + "px",
        "font-weight": this.options.tooltipTimeFontWeight
      }
    },
    startDateFlag() {
      return this.options.startDateFlag || null
    },
    endDateFlag() {
      return this.options.endDateFlag || null
    },
    dateInnerStyle3() {
      return {
        marginLeft: this.options.columnMargin + "px",
        marginRight: this.options.columnMargin + "px",
        "--dayBorderColor": this.$parseColor(this.options.dayBorderColor,{isThemeColor:this.options.dayBorderIsThemeColor}),
        "--dayBorderRadius": `${this.options.dayBorderTopLeftRadius}px ${this.options.dayBorderTopRightRadius}px ${this.options.dayBorderBottomRightRadius}px ${this.options.dayBorderBottomLeftRadius}px`,
        "--dayBgColor": this.$parseColor(this.options.dayBgColor,{isThemeColor:this.options.dayBgColorIsThemeColor}),
      }
    },
    todayLunarType() {
      return this.options ? this.options.todayLunarType : 1
    },
    selfLunarTxt() {
      return this.options ? this.options.selfLunarTxt : ""
    },
    todayLunarStyleObject() {
      return {
        "--todayColor":  this.$parseColor(this.options.todayLunarStyleColor),
        "--todayFontFamily": this.options.todayLunarStyleFontFamily,
        "--todayFontSize": this.options.todayLunarStyleFontSize + "px",
        "--todayFontWeight": this.options.todayLunarStyleFontWeight
      }
    },
    activityMarkStyle3(){
      let activityLocation = this.options.activityLocation3 || "bottom"
      let locationStr, locationStrTop, locationStrRight, locationStrLeft, locationStrBottom
      if (activityLocation === "leftTop") {
        //  顶部居左
        locationStr = {
          left: this.options.activityLeft + "px",
          right: "auto",
          top: this.options.activityTop + "px",
          bottom: "auto",
        }
      } else if (activityLocation === "top") {
        //  顶部居中
        locationStr = {
          left: "50%",
          right: "auto",
          top: this.options.activityTop + "px",
          bottom: "auto",
          transform: "translateX(-50%)"
        }
      } else if (activityLocation === "rightTop") {
        //  顶部居右
        locationStr = {
          left: "auto",
          right: this.options.activityRight + "px",
          top: this.options.activityTop + "px",
          bottom: "auto"
        }
      } else if (activityLocation === "leftBottom") {
        //  底部居左
        locationStr = {
          left: this.options.activityLeft + "px",
          right: 0,
          top: "auto",
          bottom: this.options.activityBottom + "px"
        }
      } else if (activityLocation === "bottom") {
        //  底部居中
        locationStr = {
          left: "50%",
          right: "auto",
          top: "auto",
          bottom: this.options.activityBottom + "px",
          transform: "translateX(-50%)"
        }
      } else if (activityLocation === "rightBottom") {
        //  底部居右
        locationStr = {
          left: "auto",
          right: this.options.activityRight + "px",
          top: "auto",
          bottom: this.options.activityBottom + "px"
        }
      } else if (activityLocation === "left") {
        //  左侧
        locationStr = {
          left: this.options.activityLeft + "px",
          right: "auto",
          top: "50%",
          bottom: "auto",
          transform: "translateY(-50%)"
        }
      } else {
        //  右侧
        locationStr = {
          left: "auto",
          right: this.options.activityRight + "px",
          top: "50%",
          bottom: "auto",
          transform: "translateY(-50%)"
        }
      }
      locationStrTop = locationStr.top
      locationStrRight = locationStr.right
      locationStrLeft = locationStr.left
      locationStrBottom = locationStr.bottom
      return {
        "--activityMarkTop3": locationStrTop,
        "--activityMarkRight3": locationStrRight,
        "--activityMarkLeft3": locationStrLeft,
        "--activityMarkBottom3": locationStrBottom,
        "--activityMarkTransform": locationStr.transform ? locationStr.transform : "none"
    }
    }
  },
  mounted() {
    if (this.styleId === 3) {
      this.getRangeTime()
    }
    this.updateData()
    this.$initPlugin(this.options?.pluginName)
    this.options.pluginName.forEach(item => {
      if (item.indexOf("calendarResponseDataPlugin") !== -1) {
        this.hasRelativePlugin = true
      }
    })
    this.getYearLists()
  },
  methods: {
    initListPageCalendarData(listPage) {
      const { dataLayoutOptions } = listPage
      // 初始化列表页筛选的相关功能
      this.isInListPage = true
      this.dataLayoutId = {
        container_id: 0,
        rect_id: dataLayoutOptions.rect_id
      }
    },
    initSubPageCalendarData(selectedDates, selectedDateMap, plugin) {
      // 初始化列表页筛选的相关功能
      this.isInSubPage = true
      if (selectedDates) {
        this.$changeOptionsEV(selectedDates, "selectedDates", false, null, this.ids, true)
      }
      if (selectedDateMap) {
        this.$changeOptionsEV(selectedDateMap, "selectedDateMap", false, null, this.ids, true)
      }
    },
    // 是否选中日期
    isSelected: function (slotDate, slotData) {
      // console.log("isSelected slotDate", slotDate)
      // console.log("slotData", slotData)
      return this.selectedDates?.includes(slotData.day)
    },
    // 活动日期数据
    activityDateNumber: function (slotDate, slotData) {
      let data1
      for (let i = 0; i < this.selectedDateMap.length; i++) {
        if (this.selectedDateMap[i][slotData.day]) {
          data1 = this.selectedDateMap[i][slotData.day]
          break
        }
      }
      return data1
    },
    // 是否节假日
    isFestival(slotDate, slotData) {
      let solarDayArr = slotData.day.split("-")
      let lunarDay = calendarPlugin.solar2lunar(solarDayArr[0], solarDayArr[1], solarDayArr[2])

      // 公历节日\农历节日\农历节气
      let festAndTerm = []
      festAndTerm.push(lunarDay.festival == null ? "" : " " + lunarDay.festival)
      festAndTerm.push(lunarDay.lunarFestival == null ? "" : "" + lunarDay.lunarFestival)
      festAndTerm.push(lunarDay.Term == null ? "" : "" + lunarDay.Term)
      festAndTerm = festAndTerm.join("")

      return festAndTerm != ""
    },
    // 公历转农历
    solarToLunar(slotDate, slotData) {
      let solarDayArr = slotData.day.split("-")
      let lunarDay = calendarPlugin.solar2lunar(solarDayArr[0], solarDayArr[1], solarDayArr[2])

      // 农历日期
      // let lunarMD = lunarDay.IMonthCn + lunarDay.IDayCn
      let lunarMD = lunarDay.IDayCn

      // 公历节日\农历节日\农历节气
      let festAndTerm = []
      festAndTerm.push(lunarDay.festival == null ? "" : " " + lunarDay.festival)
      festAndTerm.push(lunarDay.lunarFestival == null ? "" : "" + lunarDay.lunarFestival)
      festAndTerm.push(lunarDay.Term == null ? "" : "" + lunarDay.Term)
      festAndTerm = festAndTerm.join("")

      return festAndTerm == "" ? lunarMD : festAndTerm
    },
    selectDate(type) {
      if (validTypes.indexOf(type) === -1) {
        throw new Error(`invalid type ${type}`)
      }
      if (this.styleId === 3) {
        if (type === "prev-month") {
          this.tapPrev()
        } else if (type === "next-month") {
          this.tapNext()
        }
        return
      }
      let day = ""
      if (type === "prev-month") {
        day = this.$refs.elCalendar.prevMonthDatePrefix + "-01"
        if (this.hasRelativePlugin) {
          this.options.pickDate = this.$refs.elCalendar.prevMonthDatePrefix + "-1"
          this.$changeOptionsEV(true, "selectMonth", false, null, this.myid, true)
        }
      } else if (type === "next-month") {
        day = this.$refs.elCalendar.nextMonthDatePrefix + "-01"
        if (this.hasRelativePlugin) {
          this.options.pickDate = this.$refs.elCalendar.nextMonthDatePrefix + "-1"
          this.$changeOptionsEV(true, "selectMonth", false, null, this.myid, true)
        }
      } else {
        day = this.$refs.elCalendar.formatedToday
      }
      this.calendarValue = day
    },
    pickDay(date) {
      console.log("pickDay", date)
      let pickerDateY = date.getFullYear()
      let pickerDateM =
        Number(date.getMonth() + 1) < 10 ? "0" + Number(date.getMonth() + 1) : Number(date.getMonth() + 1)
      let pickerDateD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      this.options.pickDate = pickerDateY + "-" + pickerDateM + "-" + pickerDateD
      if (this.hasRelativePlugin) {
        this.$changeOptionsEV(false, "selectMonth", false, null, this.myid, true)
        if (this.styleId === 3) {
          this.$changeOptionsEV(false, "selectWeek", false, null, this.myid, true)
        }
      }
      if (this.options.restDataUrl && this.styleId === 2) {
        //请求当天的数据
        this.selectedDay = true
        // this.updateData()
      }
      // 如果是在列表页，通知自由布局更新数据
      if (this.isInListPage && (this.styleId === 1 || this.styleId === 3)) {
        let filterDateVal = ''
        if (!this.options.filterStartDateFlag || !this.options.filterEndDateFlag || !this.options.pickDate) {
          filterDateVal = null
        } else {
          filterDateVal = [this.options.filterStartDateFlag, this.options.filterEndDateFlag, this.options.pickDate, this.options.pickDate]
        }

        this.$eventBus.$emit(
          `update-layout-data-eventBus-${this.dataLayoutId?.container_id}-${this.dataLayoutId?.rect_id}`,
          {
            dateVal: filterDateVal
          }
        )
      }
      if (this.isInSubPage && (this.styleId === 1 || this.styleId === 3)) {
        let filterDateVal = null
        if (!this.options.filterStartDateFlag || !this.options.filterEndDateFlag || !this.options.pickDate) {
          filterDateVal = null
        } else {
          filterDateVal = [this.options.filterStartDateFlag, this.options.filterEndDateFlag, this.options.pickDate, this.options.pickDate]
        }
        this.dispatchListPageRefreshData(filterDateVal)
      }
    },
    // 触发列表页数据刷新
    dispatchListPageRefreshData(value) {
      if (value && this.$subPageEvent.contexts) {
        Object.keys(this.$subPageEvent.contexts).forEach(key => {
          if (key.indexOf("cxDataGrid") !== -1) {
            this.$eventBus.$emit("subPage-component-init", {
              type: key,
              dateVal: value
            })
          }
        })
      }
    },
    changeSelectOptionMonth() {
      let day = this.dateYearStyle + "-" + this.dateMonthStyle + "-01"
      this.options.pickDate = day
      this.calendarValue = day
      this.selectedDay = false
      this.updateData()
    },
    changeSelectOptionYear() {
      let day = this.dateYearStyle + "-" + this.dateMonthStyle + "-01"
      this.options.pickDate = day
      this.calendarValue = day
      this.selectedDay = false
      this.updateData()
    },
    //  获取年份列表
    getYearLists() {
      let year = this.calendarValue.getFullYear()
      var params = []
      for (var i = 20; i > 0; i--) {
        params.push({ value: year - i, label: year - i })
      }
      for (var i = 0; i < 30; i++) {
        params.push({ value: year + i, label: year + i })
      }
      this.dateYearOptions = params
    },
    async updateData() {
      if (this.options.restDataUrl) {
        this.getBaseModuleDataLoop()
      }
    },
    async getBaseModuleDataLoop() {
      if (this.startDateFlag === null || this.startDateFlag === null) {
        return
      }
      let sd,
        ed,
        calendarValue = new Date(),
        lastDay
      let pickData = this.options.pickDate
      if (!pickData) {
        let pickerDateY = calendarValue.getFullYear()
        let pickerDateM =
          Number(calendarValue.getMonth() + 1) < 10
            ? "0" + Number(calendarValue.getMonth() + 1)
            : Number(calendarValue.getMonth() + 1)
        let pickerDateD = calendarValue.getDate() < 10 ? "0" + calendarValue.getDate() : calendarValue.getDate()
        sd = pickerDateY + "-" + pickerDateM + "-" + pickerDateD
        //获取最后一天
        var date = new Date()
        date.setMonth(date.getMonth() + 1)
        date.setDate(0)
        lastDay = date.getDate()
        ed = pickerDateY + "-" + pickerDateM + "-" + lastDay
      }
      else if(this.selectedDay) {
        sd =  pickData
        ed = pickData
      } else {
        let arr1 = pickData.split("-")
        sd = arr1[0] + "-" + (Number(arr1[1]) < 10 ? "0" + Number(arr1[1]) : Number(arr1[1])) + "-01"
        let date1 = new Date()
        let month = Number(arr1[1])
        date1.setYear(Number(arr1[0]))
        date1.setMonth(month < 12 ? month : 12)
        date1.setDate(0)
        if (month > 11) {
          lastDay = 31
        } else {
          lastDay = date1.getDate()
        }
        ed = arr1[0] + "-" + (Number(arr1[1]) < 10 ? "0" + Number(arr1[1]) : Number(arr1[1])) + "-" + lastDay
      }
      let filterValue = "&sd=" + sd + "&sf=" + this.startDateFlag + "&ed=" + ed + "&ef=" + this.endDateFlag
      let result = await this.getAppointData(filterValue)
      if (result.data && result.data.code === 1) {
        this.renderDatas(result)
      }
    },
    //渲染数据
    renderDatas(datas) {
      let selectedDatesContent = datas?.data?.data?.datas
      let selectedDates = datas?.data?.data?.dateStrs || []
      let selectedDateMap = datas?.data?.data?.dateStrsMap || []
      if(!this.selectedDay){
        this.$changeOptionsEV(selectedDates, "selectedDates", false, null, this.ids, true)
        this.$changeOptionsEV(selectedDateMap, "selectedDateMap", false, null, this.ids, true)
      }
      let activityLists = []
      if (selectedDatesContent && selectedDatesContent.length > 0) {
        for (let i = 0; i < selectedDatesContent.length; i++) {
          let list1 = {}
          if (selectedDatesContent[i][1] && selectedDatesContent[i][1].value) {
            list1.title = selectedDatesContent[i][1].value
          }
          // 开始日期和结束日期标志不一致，代表选择日期范围
          if(this.startDateFlag !== this.endDateFlag){
            if(selectedDatesContent[i][this.startDateFlag] && selectedDatesContent[i][this.startDateFlag].value){
              list1.timeStart = selectedDatesContent[i][this.startDateFlag].value
              // 时间格式必须是 yyyy-MM-dd HH:mm:ss
              list1.timeStartStr = list1.timeStart.split(" ")[0]
            }
            if(selectedDatesContent[i][this.endDateFlag] && selectedDatesContent[i][this.endDateFlag].value){
              list1.timeEnd = selectedDatesContent[i][this.endDateFlag].value
              // 时间格式必须是 yyyy-MM-dd HH:mm:ss
              list1.timeEndStr = list1.timeEnd.split(" ")[0]
            }
          }else{
            let flag = 6
            if(this.endDateFlag){
              flag = this.endDateFlag
            }else if(this.startDateFlag){
              flag = this.startDateFlag
            }
            if(selectedDatesContent[i][flag] && selectedDatesContent[i][flag].value){
              list1.time = selectedDatesContent[i][flag].value
              // 时间格式必须是 yyyy-MM-dd HH:mm:ss
              list1.timeStr = list1.time.split(" ")[0]
            }
          }
          if (list1 !== {}) {
            activityLists.push(list1)
          }
        }
      }
      this.$changeOptionsEV(activityLists, "activityLists", false, null, this.ids, true)
    },
    async getAppointData(filterValue) {
      return this.instance.get(this.options.restDataUrl + filterValue)
    },
    isDateInRange(startDateStr, endDateStr, targetDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);
      const targetDate = new Date(targetDateStr);
      return targetDate >= startDate && targetDate <= endDate;
    },
    isDateHasData(item, data){
      if(this.startDateFlag !== this.endDateFlag){
        return this.isDateInRange(item.timeStartStr, item.timeEndStr, data.day)
      }else{
        return item.timeStr == data.day
      }
    },
    // 样式3获取日期范围
    getRangeTime() {
      let oneDayTime = 1000 * 60 * 60 * 24
      let today = new Date()
      let todayDay = today.getDay() || 7
      let weekFirstNumber = 1
      if (this.firstDayOfWeek === 7) {
        weekFirstNumber = 0
      }
      let startDate = new Date(today.getTime() - oneDayTime * (todayDay - weekFirstNumber))
      let dateList = []
      for (let i = 0; i < 7; i++) {
        let temp = new Date(startDate.getTime() + i * oneDayTime)
        let year = temp.getFullYear()
        let month = temp.getMonth() + 1 < 10 ? "0" + (temp.getMonth() + 1) : temp.getMonth() + 1
        let day = temp.getDate() < 10 ? "0" + temp.getDate() : temp.getDate()
        dateList[i] = `${year}-${month}-${day}`
      }
      // 以下是根据实际情况进行赋值
      this.starttime = dateList[0]
      this.endtime = dateList[dateList.length - 1]

      // this.calendarValue = new Date(dateList[0])
      //  dateList为当前日期所在一周的数据
      // return dateList
    },
    // 点击上一周的方法
    tapPrev() {
      this.getTime(-7, this.starttime)
    },
    // 点击下一周的方法
    tapNext() {
      this.getTime(7, this.starttime)
    },
    getTime(time, datenum) {
      let _this = this
      //  time = 7下周  -7上周   0本周
      let date = new Date(datenum) //this.chaoZuoTime
      let currentFirstDate = new Date(date)

      let formatDate = function (date) {
        let year = date.getFullYear() //年
        let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
        return year + "-" + month + "-" + day
      }
      let addDate = function (date, n) {
        date.setDate(date.getDate() + n)
        return date
      }
      let setDate = function (date) {
        let weekFirstNumber = 1
        if (_this.firstDayOfWeek === 7) {
          weekFirstNumber = 0
        }
        let week = date.getDay() - weekFirstNumber
        date = addDate(date, week * -1)
        currentFirstDate = new Date(date)
        let weekList = []
        for (let i = 0; i < 7; i++) {
          weekList[i] = formatDate(i == 0 ? date : addDate(date, 1))
        }
        return weekList
      }
      let thisWeek = []
      thisWeek = setDate(addDate(currentFirstDate, time)) //  获取到上一周 / 下一周的日期数据

      //以下是根据实际情况赋值
      this.starttime = thisWeek[0]
      this.endtime = thisWeek[thisWeek.length - 1]
      // this.calendarValue = new Date(thisWeek[0])
      this.getWeekNumber(thisWeek[0])
      if (this.hasRelativePlugin) {
        this.options.pickDate = this.starttime
        this.$changeOptionsEV(true, "selectWeek", false, null, this.myid, true)
      }
      this.getCalendarTitle(thisWeek[0])
    },
    // 点击上一周、下一周的同时我们还要获取到该周为当年的第几周：
    isLeapYear(year) {
      return year % 400 == 0 || (year % 4 == 0 && year % 100 != 0)
    },
    getMonthDays(year, month) {
      return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month] || (this.isLeapYear(year) ? 29 : 28)
    },
    // date为某一个日期：'2023-08-08'
    getWeekNumber(date) {
      var now = new Date(date),
        year = now.getFullYear(),
        month = now.getMonth(),
        days = now.getDate()
      for (var i = 0; i < month; i++) {
        days += this.getMonthDays(year, i)
      }
      var yearFirstDay = new Date(year, 0, 1).getDay() || 7
      var week = null
      if (yearFirstDay == 1) {
        week = Math.ceil(days / yearFirstDay)
      } else {
        days -= 7 - yearFirstDay + 1
        week = Math.ceil(days / 7) + 1
      }
    },
    getCalendarTitle(dateStr){
      let calendarValue = new Date(dateStr)
      let pickerDateY = calendarValue.getFullYear()
      let pickerDateM = calendarValue.getMonth() + 1
      let showDate = ""
      switch (this.options.dateStyle) {
        case "1":
          // "2021年11月"
          showDate = `yyyy年MM月`
          if (this.$refs.elCalendar && pickerDateM < 9) {
            pickerDateM = "0" + pickerDateM
          }
          showDate = pickerDateY + "年" + pickerDateM + "月"
          break
        case "2":
          // "2021年 十一月"
          var str = "一"
          if (pickerDateM) {
            if (pickerDateM == 2) {
              str = "二"
            } else if (pickerDateM == 3) {
              str = "三"
            } else if (pickerDateM == 4) {
              str = "四"
            } else if (pickerDateM == 5) {
              str = "五"
            } else if (pickerDateM == 6) {
              str = "六"
            } else if (pickerDateM == 7) {
              str = "七"
            } else if (pickerDateM == 8) {
              str = "八"
            } else if (pickerDateM == 9) {
              str = "九"
            } else if (pickerDateM == 10) {
              str = "十"
            } else if (pickerDateM == 11) {
              str = "十一"
            } else if (pickerDateM == 12) {
              str = "十二"
            } else {
              str = "一"
            }
          }
          // showDate = `yyyy年` + str + `月`
          showDate = pickerDateY + "年" + str + "月"
          break
        case "3":
          // showDate = `yyyy-MM`
          if (pickerDateM < 10) {
            pickerDateM = "0" + pickerDateM
          }
          showDate = pickerDateY + "-" + pickerDateM
          break
        case "4":
          // showDate = `yyyy / MM`
          if (pickerDateM < 10) {
            pickerDateM = "0" + pickerDateM
          }
          showDate = pickerDateY + " / " + pickerDateM
          break
        default:
      }
      this.calendarTitle = showDate
    }
  }
}
</script>

<style scoped>
.calendar-component {
  position: relative;
  height: 100%;
  width: 100%;
}
/* 多行下的日历日期是偏左的 */
.calendar-component >>> .el-calendar-table {
  text-align: center;
}
.calendar-component >>> .el-calendar-table .el-calendar-day {
  position: relative;
  height: auto;
  border-radius: 50%;
  /* 产品要求取消 */
  padding: 0;
}
.calendar-component >>> .el-calendar-table td,
.calendar-component >>> .el-calendar-table tr td:first-child,
.calendar-component >>> .el-calendar-table tr:first-child td {
  border: 0;
}
.calendar-component >>> .el-calendar {
  background-color: transparent;
}
.calendar-component >>> .el-calendar__header {
  display: none;
}
.calendar-component >>> .el-calendar .el-calendar__body {
  padding: 0;
}
.calendar-component .calendar-title {
  position: relative;
}
.calendar-component .calendar-title .title-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background-color: transparent;
  color: inherit;
}
.calendar-component .calendar-title .title-btn .bg-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-component .calendar-title .title-btn .bg-box > div {
  display: inline-block;
  vertical-align: middle;
}
.calendar-component .calendar-title .next-month .bg-box > div,
.calendar-component .calendar-title .next-month .bg-box > img {
  transform: rotate(180deg);
}

.calendar-component .calendar-title .prev-month {
  left: 0;
}
.calendar-component .calendar-title .next-month {
  right: 0;
}
.calendar-component .calendar-title .title-txt {
  width: calc(100% - 70px);
  display: inline-block;
  text-decoration: inherit;
  text-decoration-color: initial;
}
.calendar-component .calendar-footer * {
  display: inline-block;
  vertical-align: middle;
}

.calendar-component .calendar-footer .icon-today i {
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: 1px solid #2b67ff;
}

.calendar-component .calendar-footer .icon-activity i {
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #2b67ff;
  border: 1px solid #2b67ff;
}
.calendar-component >>> .el-calendar-table tr td.is-today {
  color: inherit;
  background-color: transparent;
}
.calendar-component >>> .el-calendar-table tr td .el-calendar-day .solar {
  width: 32px;
  height: 32px;
  line-height: 30px;
  box-sizing: border-box;
  border-radius: 50%;
  margin: 0 auto;
  border-width: 2px;
}

.calendar-component >>> .el-calendar-table .el-calendar-day:hover {
  background-color: transparent;
}
.calendar-component >>> .el-calendar-table .el-calendar-day:hover .solar {
  background-color: rgba(43, 103, 255, 0.16);
}
.calendar-component >>> .el-calendar-table .el-calendar-day .lunar {
  color: var(--lunarColor);
  font-family: var(--lunarFontFamily);
  font-weight: var(--lunarFontWeight);
  font-size: var(--lunarFontSize);
}
.calendar-component >>> .day-box-style1 .el-calendar-table tr td .el-calendar-day .lunar {
  color: var(--lunarColor);
  font-family: var(--lunarFontFamily);
  font-weight: var(--lunarFontWeight);
  font-size: var(--lunarFontSize);
}
.calendar-component >>> .day-box-style1 .el-calendar-table tr td .el-calendar-day:hover .lunar {
  color: var(--hoverLunarColor);
  font-family: var(--hoverLunarFontFamily);
  font-weight: var(--hoverLunarFontWeight);
  font-size: var(--hoverLunarFontSize);
}
.calendar-component >>> .day-box-style2 .el-calendar-table tr td .el-calendar-day:hover .lunar {
  color: var(--hoverLunarColor);
  font-family: var(--hoverLunarFontFamily);
  font-weight: var(--hoverLunarFontWeight);
  font-size: var(--hoverLunarFontSize);
}
.calendar-component >>> .day-box-style3:hover .lunar {
  color: var(--hoverLunarColor);
  font-family: var(--hoverLunarFontFamily);
  font-weight: var(--hoverLunarFontWeight);
  font-size: var(--hoverLunarFontSize);
}
.calendar-component >>> .day-box-style1 .el-calendar-table tr td.is-selected .el-calendar-day .lunar {
  color: var(--activeLunarColor);
  font-family: var(--activeLunarFontFamily);
  font-weight: var(--activeLunarFontWeight);
  font-size: var(--activeLunarFontSize);
}

.calendar-component >>> .day-box-style2 .el-calendar-table tr td.is-selected .el-calendar-day .lunar {
  color: var(--activeLunarColor);
  font-family: var(--activeLunarFontFamily);
  font-weight: var(--activeLunarFontWeight);
  font-size: var(--activeLunarFontSize);
}
.calendar-component .el-calendar-table td.is-selected .el-calendar-day .day-box-style3 .lunar {
  color: var(--activeLunarColor);
  font-family: var(--activeLunarFontFamily);
  font-weight: var(--activeLunarFontWeight);
  font-size: var(--activeLunarFontSize);
}
.calendar-component >>> .day-box-style1 .el-calendar-table tr td .el-calendar-day:hover .activity-mark,
.calendar-component >>> .day-box-style1 .el-calendar-table tr td.selected .el-calendar-day .lunar,
.calendar-component >>> .day-box-style1 .el-calendar-table tr td.is-selected .el-calendar-day .lunar,
.calendar-component >>> .day-box-style1 .el-calendar-table tr td.is-today .el-calendar-day .lunar {
  /*display: none;*/
}
.calendar-component >>> .hide-todayStyle .el-calendar-table tr td.is-today .el-calendar-day .lunar {
  display: block;
}
.calendar-component >>> .el-calendar-table .el-calendar-day .selected .activity-mark {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  display: inline-block;
  width: var(--activityWidth);
  height: var(--activityWidth);
  background-color: var(--activityColor);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.calendar-component >>> .el-calendar-table thead {
  background-color: var(--weekBgColor);
}
.calendar-component >>> .el-calendar-table thead th {
  color: var(--weekColor);
  font-family: var(--weekFontFamily);
  font-weight: var(--weekFontWeight);
  font-size: var(--weekFontSize);
}
.calendar-component >>> .hide-notCurrentDate .el-calendar-table td.prev .el-calendar-day,
.calendar-component >>> .hide-notCurrentDate .el-calendar-table td.next .el-calendar-day {
  display: none;
}
.calendar-component >>> .el-calendar-table td.prev .el-calendar-day .solar,
.calendar-component >>> .el-calendar-table td.next .el-calendar-day .solar {
  color: var(--notCurrentTextColor);
}
.calendar-component >>> .el-calendar-table .el-calendar-day:hover .solar {
  color: var(--hoverColor);
  font-family: var(--hoverFontFamily);
  font-weight: var(--hoverFontWeight);
  font-size: var(--hoverFontSize);
  border-top-left-radius: var(--hoverBorderTopLeftRadius);
  border-top-right-radius: var(--hoverBorderTopRightRadius);
  border-bottom-right-radius: var(--hoverBorderBottomRightRadius);
  border-bottom-left-radius: var(--hoverBorderBottomLeftRadius);
  background-color: var(--hoverBgColor);
  border-color: var(--hoverBorderColor);
  border-style: var(--hoverBorderStyle);
  border-width: var(--hoverBorderWidth);
}
.calendar-component >>> .el-calendar-table td.is-selected {
  background-color: transparent;
}

.calendar-component >>> .el-calendar-table td.is-selected .el-calendar-day .solar,
.calendar-component >>> .el-calendar-table td.is-today.is-selected .el-calendar-day .solar {
  color: var(--activeColor);
  font-family: var(--activeFontFamily);
  font-weight: var(--activeFontWeight);
  font-size: var(--activeFontSize);
  border-top-left-radius: var(--activeBorderTopLeftRadius);
  border-top-right-radius: var(--activeBorderTopRightRadius);
  border-bottom-right-radius: var(--activeBorderBottomRightRadius);
  border-bottom-left-radius: var(--activeBorderBottomLeftRadius);
  background-color: var(--activeBgColor);
  border-color: var(--activeBorderColor);
  border-style: var(--activeBorderStyle);
  border-width: var(--activeBorderWidth);
}
.calendar-component >>> .el-calendar-table td .el-calendar-day .day-box {
  padding-top: var(--datePaddingTopVal);
  padding-bottom: var(--datePaddingBottomVal);
}
.calendar-component >>> .el-calendar-table td .el-calendar-day .day-box:hover {
  background-color: var(--hoverAllBgColor);
  border-top-left-radius: var(--hoverBorderTopLeftRadius);
  border-top-right-radius: var(--hoverBorderTopRightRadius);
  border-bottom-right-radius: var(--hoverBorderBottomRightRadius);
  border-bottom-left-radius: var(--hoverBorderBottomLeftRadius);
}
.calendar-component >>> .el-calendar-table td.is-selected .el-calendar-day .day-box,
.calendar-component >>> .el-calendar-table td.is-selected.is-today .el-calendar-day .day-box {
  background-color: var(--activeAllBgColor);
  border-top-left-radius: var(--activeBorderTopLeftRadius);
  border-top-right-radius: var(--activeBorderTopRightRadius);
  border-bottom-right-radius: var(--activeBorderBottomRightRadius);
  border-bottom-left-radius: var(--activeBorderBottomLeftRadius);
}
.calendar-component >>> .el-calendar-table td.is-today .el-calendar-day .day-box {
  background-color: var(--todayAllBgColor);
  border-top-left-radius: var(--todayStyleBorderTopLeftRadius);
  border-top-right-radius: var(--todayStyleBorderTopRightRadius);
  border-bottom-right-radius: var(--todayStyleBorderBottomRightRadius);
  border-bottom-left-radius: var(--todayStyleBorderBottomLeftRadius);
}
.calendar-component >>> .el-calendar-table td.is-today .el-calendar-day .solar {
  color: var(--todayStyleColor);
  font-family: var(--todayStyleFontFamily);
  font-weight: var(--todayStyleFontWeight);
  font-size: var(--todayStyleFontSize);
  border-top-left-radius: var(--todayStyleBorderTopLeftRadius);
  border-top-right-radius: var(--todayStyleBorderTopRightRadius);
  border-bottom-right-radius: var(--todayStyleBorderBottomRightRadius);
  border-bottom-left-radius: var(--todayStyleBorderBottomLeftRadius);
  background-color: var(--todayStyleBgColor);
  border-color: var(--todayStyleBorderColor);
  border-style: var(--todayStyleBorderStyle);
  border-width: var(--todayStyleBorderWidth);
}
.calendar-component >>> .el-calendar-table .el-calendar-day .selected .solar {
  color: var(--activityFontColor);
  font-family: var(--activityFontFamily);
  font-weight: var(--activityFontWeight);
  font-size: var(--activityFontSize);
}
.calendar-component >>> .el-calendar-table .el-calendar-day .activity-mark.activity-mark-number {
  position: absolute;
  transform: translateX(-50%);
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  top: var(--activityMarkTop);
  right: var(--activityMarkRight);
  left: var(--activityMarkLeft);
  bottom: var(--activityMarkBottom);
}
.flex-right {
  display: flex;
  justify-content: right;
}
.calendar-title-select ::v-deep.el-input .el-input__inner {
  /*background-color: #363b5d;*/
  background-color: var(--topSelectBgColor);
  color: inherit;
  font-weight: inherit;
  font-style: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-decoration: var(--titleTextDecoration);
  font-size: var(--titleFontSize);
  font-family: var(--titleFontFamily);
  height: var(--titleLineHeight);
}
.calendar-title-select ::v-deep.el-select .el-input__suffix-inner {
  letter-spacing: 0;
}
.calendar-title-select ::v-deep.el-input__suffix,
.calendar-title-select ::v-deep.el-input__suffix .el-select__caret {
  color: inherit;
}
.calendar-title-select ::v-deep.el-select {
  /*width: 120px;*/
  width: var(--selectWidth);
}
.calendar-title-select ::v-deep.el-select .el-select-dropdown {
  width: var(--selectWidth);
  min-width: var(--selectWidth) !important;
}
.activity-tooltip {
  position: absolute;
  background: #6c6565;
  z-index: 1;
  color: white;
  text-align: left;
  display: none;
  border-radius: var(--tooltipBorderRadius);
  border-width: var(--tooltipBorderWidth);
  border-style: var(--tooltipBorderStyle);
  border-color: var(--tooltipBorderColor);
  box-shadow: var(--activityTooltipBoxshadow);
}
.el-calendar-day:hover .activity-tooltip {
  display: block;
}

.activity-tooltip ul {
  max-height: 100%;
  overflow-y: auto;
}
.activity-tooltip ul::-webkit-scrollbar {
  width: 8px;
  height: 6px;
}
.activity-tooltip ul::-webkit-scrollbar-thumb {
  background: rgba(133, 136, 158, 1);
  border-radius: 3px;
}
.activity-tooltip li {
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
}
</style>
<style>
.el-popper.date-select {
  left: 0 !important;
  background-color: transparent;
  padding: var(--titleSelectPadding);
}
.el-popper.date-select .el-scrollbar {
  background-color: var(--titleSelectBgColor);
  border-width: var(--titleSelectBorderWidth);
  border-style: var(--titleSelectBorderStyle);
  border-color: var(--titleSelectBorderColor);
  border-radius: var(--titleSelectBorderRadius);
  box-shadow: var(--titleSelectBoxshadow);
}
.el-popper.date-select .el-select-dropdown__list {
  background-color: transparent !important;
  border: 0;
}
.el-popper.date-select .el-scrollbar .el-scrollbar__wrap {
  margin-bottom: -15px !important;
  overflow-x: hidden;
}
.el-popper.date-select .el-scrollbar .el-select-dropdown__item {
  color: var(--titleSelectColor) !important;
  height: var(--titleSelectLineHeight);
  line-height: var(--titleSelectLineHeight);
  font-family: var(--titleSelectFontFamily);
  font-size: var(--titleSelectFontSize);
  font-weight: var(--titleSelectFontWeight);
  background-color: var(--titleSelectOptionsBgColor);
}
.el-popper.date-select .el-scrollbar .el-select-dropdown__item:hover,
.el-popper.date-select .el-scrollbar .el-select-dropdown__item.selected {
  color: var(--titleSelectActiveColor) !important;
  font-family: var(--titleSelectActiveFontFamily);
  font-size: var(--titleSelectActiveFontSize);
  font-weight: var(--titleSelectActiveFontWeight);
  background-color: var(--titleSelectActiveBgColor);
}
</style>
<style lang="scss" scoped>
.calendar-component {
  .el-calendar-table {
    td {
      .el-calendar-day {
        .day-box-style3.day-box {
          border-width: 1px;
          border-style: solid;
          border-color: var(--dayBorderColor);
          border-radius: var(--dayBorderRadius);
          background-color: var(--dayBgColor);
          &:hover {
            background-color: var(--hoverBgColor);
            border-color: var(--hoverBorderColor);
            border-style: var(--hoverBorderStyle);
            border-width: var(--hoverBorderWidth);
          }
          .lunar {
            .lunar-self{
              display: none;
            }
          }
          .activity-mark {
            position: absolute;
            transform: var(--activityMarkTransform);
            top: var(--activityMarkTop3);
            right: var(--activityMarkRight3);
            left: var(--activityMarkLeft3);
            bottom: var(--activityMarkBottom3);
          }
        }
        &:hover {
          .day-box-style3.day-box {
            border-top-left-radius: var(--hoverBorderTopLeftRadius);
            border-top-right-radius: var(--hoverBorderTopRightRadius);
            border-bottom-right-radius: var(--hoverBorderBottomRightRadius);
            border-bottom-left-radius: var(--hoverBorderBottomLeftRadius);
            .solar {
              background-color: transparent;
              border: 0;
            }
          }
        }
      }
      &.is-today {
        .el-calendar-day {
          .day-box-style3.day-box {
            border-top-left-radius: var(--todayStyleBorderTopLeftRadius);
            border-top-right-radius: var(--todayStyleBorderTopRightRadius);
            border-bottom-right-radius: var(--todayStyleBorderBottomRightRadius);
            border-bottom-left-radius: var(--todayStyleBorderBottomLeftRadius);
            background-color: var(--todayStyleBgColor);
            border-color: var(--todayStyleBorderColor);
            border-style: var(--todayStyleBorderStyle);
            border-width: var(--todayStyleBorderWidth);
            .solar {
              -webkit-border-radius: 0;
              -moz-border-radius: 0;
              border-radius: 0;
              background-color: transparent;
              border: 0 solid transparent;
            }
            .lunar {
              &.lunarTxt1{
                .lunar-self{
                  display: none;
                }
              }
              &.lunarTxt2{
                .lunar-default{
                  display: none;
                }
                .lunar-self{
                  display: block;
                  color: var(--todayColor);
                  font-family: var(--todayFontFamily);
                  font-size: var(--todayFontSize);
                  font-weight: var(--todayFontWeight);
                }
              }
              &.lunarTxt3{
                .lunar-default{
                  color: transparent;
                }
                .lunar-self{
                  display: none;
                }
              }
            }
          }
        }
      }
      &.is-selected {
        .el-calendar-day {
          .day-box-style3 {
            border-top-left-radius: var(--activeBorderTopLeftRadius);
            border-top-right-radius: var(--activeBorderTopRightRadius);
            border-bottom-right-radius: var(--activeBorderBottomRightRadius);
            border-bottom-left-radius: var(--activeBorderBottomLeftRadius);
            background-color: var(--activeBgColor);
            border-color: var(--activeBorderColor);
            border-style: var(--activeBorderStyle);
            border-width: var(--activeBorderWidth);
            .solar {
              border-radius: 0;
              background-color: transparent;
              border: 0 solid transparent;
            }
          }
        }
      }
    }
  }
}
</style>
